import { useEffect, useState } from "react";

const links = [
  { href: "#home", label: "本站首页" },
  { href: "#entries", label: "官方入口" },
  { href: "#explore", label: "热门看点" },
  { href: "#channels", label: "常用分区" },
  { href: "#news", label: "更新动态" },
  { href: "#guide", label: "使用帮助" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/85 backdrop-blur border-b border-secondary-200/70" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <a href="#home" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="grid place-items-center w-8 h-8 rounded-lg bg-primary-500 text-background-50 text-lg font-bold">
              17
            </span>
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">吃瓜17 导航入口</span>
          </a>

          <nav className="hidden md:flex items-center gap-7">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-sm text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button
              type="button"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium border border-secondary-300 bg-background-50 text-foreground-800 hover:bg-secondary-100 transition-colors"
            >
              <i className="ri-bookmark-line text-base" />
              收藏本页
            </button>
            <a
              href="#entries"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-4 py-2 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 transition-colors"
            >
              一键直达
              <i className="ri-arrow-right-up-line text-base" />
            </a>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            className="md:hidden grid place-items-center w-9 h-9 rounded-md text-foreground-800 border border-secondary-300 bg-background-50"
            onClick={() => setOpen((v) => !v)}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-secondary-200 bg-background-50 px-4 py-3">
          <nav className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-2.5 text-sm text-foreground-800 hover:text-primary-600 border-b border-secondary-100 last:border-0"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <button
            type="button"
            className="mt-3 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-4 py-2 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600"
          >
            <i className="ri-bookmark-line text-base" />
            收藏本站入口
          </button>
        </div>
      )}
    </header>
  );
}